/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationCancelEnrollmentDataViewModel } from "../types/CourseRegistrationCancelEnrollmentDataViewModel.ts";

export const courseRegistrationCancelEnrollmentDataViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula a ser cancelada."),
  ),
  newEnrollmentStatus: z.optional(
    z
      .number()
      .int()
      .describe(
        "Novo status da matrícula após o cancelamento. Enum EEnrollmentStatus: `1` = PaymentSelection, `2` = PaymentPending, `3` = ApprovalPending, `4` = Approved, `5` = Activating, `6` = Active, `7` = Transferred, `8` = TransferredInRegistration, `9` = Canceled, `10` = CanceledInRegistration, `11` = Rejected, `12` = FinishedWithPendencies, `13` = Finished, `14` = FinishedWithMonograph, `15` = FinishedWithCertificate, `16` = Blocked.",
      ),
  ),
  confirmationMessage: z
    .string()
    .describe(
      "Mensagem de confirmação exibida ao usuário antes de concluir o cancelamento. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<CourseRegistrationCancelEnrollmentDataViewModel>;
